exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.panel-title[data-v-07aeedc4] {\n  margin-bottom: 1rem;\n}\n.comment-input[data-v-07aeedc4] {\n  border: none;\n  display: flex;\n  padding: 2rem 2rem;\n  background-color: #F4F8FB !important;\n  border-radius: 10px;\n  align-items: flex-end;\n  overflow-x: hidden;\n}\n", ""]);

